import { axiosPost } from '../ServiceBase';

export const getMedicamentosTramitesIniciadosAutorizados = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/medicamentos-tablero/medicamentos',
    data,
  );
  return response;
};

export const getMedicamentosTramitesPorDelegacion = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/medicamentos-tablero/medicamentos-por-sede',
    data,
  );
  return response;
};

export const getMedicamentosTramitesPorAuditor = async (data) => {
  const response = null;
  return response;
};
